import { render, staticRenderFns } from "./rudao.vue?vue&type=template&id=feba7d22&"
import script from "./rudao.vue?vue&type=script&lang=js&"
export * from "./rudao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports